export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "项目基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "招标公告编号：",
            type: "input",
            value: "announcementId",
            disabled: true,
          },
          {
            label: "项目名称：",
            type: "input",
            value: "prjName",
            disabled: true,
          },
          {
            label: "标段号：",
            type: "input",
            value: "section",
            disabled: true,
          },
          {
            label: "招标内容：",
            type: "input",
            value: "tenderContent",
            disabled: true,
          },
          {
            label: "招标类别：",
            type: "input",
            value: "tenderClassNumName",
            disabled: true,
          },
          {
            label: "招标方式：",
            type: "input",
            value: "tenderTypeNumName",
            disabled: true,
          },
        ]
      },
      {
        title: "中标单位信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "中标单位名称：",
            type: "input",
            value: "corpName",
            disabled: true,
          },
          {
            label: "项目负责人（总监）：",
            type: "input",
            value: "personName",
            disabled: true,
          },
          {
            label: "中标价（万元）：",
            type: "input",
            value: "winningPrice",
            disabled: true,
          },
        ]
      },
      {
        title: "证照及证明文件扫描件",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "证照及证明文件扫描件：",
            type: "slot",
            slotName: "uploadFile",
          },
        ]
      },
      {
        title: "状态",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "状态：",
            type: "input",
            value: "stateName",
            disabled: true,
          },
          {
            label: "历史审核记录：",
            type: "slot",
            class: "list",
            slotName: "auditBtn",
          },
        ]
      },
    ];
  }
}
